
export function withSpace(str){
  const regexp = /\s/
  const result = regexp.test(str);
  // console.log(`testing ${str} ${result}`);
  return result;
}

export function isPasswordSecure(str){
  const regexp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&+=_-])[A-Za-z\d@$!%*?&+=_-]{8,}$/
  return regexp.test(str);
}


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/checker.js